import chatSticker from "../../../assets/starting-teacher/sticker-chat.png";
import courseSticker from "../../../assets/starting-teacher/sticker-course.png";
import emptySticker from "../../../assets/starting-teacher/sticker-empty.png";
import learnSticker from "../../../assets/starting-teacher/sticker-learn.png";
import practiceSticker from "../../../assets/starting-teacher/sticker-practice.png";
import skillAchieved from "../../../assets/starting-teacher/skill-achieved.png";
import type { StartingTeacherTaskId } from "../data/starting-teacher-route.js";

const stickers = {
  course: courseSticker,
  learn: learnSticker,
  practice: practiceSticker,
  chat: chatSticker,
} as const satisfies Record<StartingTeacherTaskId, string>;

function StickerImage({ src, label }: { src: string; label?: string }) {
  return <img alt={label ?? ""} className="block size-20" height={80} src={src} width={80} />;
}

export function StartingTeacherSticker({ task, label }: { task: StartingTeacherTaskId; label: string }) {
  return <StickerImage label={label} src={stickers[task]} />;
}

export function StartingTeacherEmptySticker() {
  return <StickerImage src={emptySticker} />;
}

export function StartingTeacherSkillBadge({ label }: { label: string }) {
  return <StickerImage label={label} src={skillAchieved} />;
}
